import styled, { css, StyledComponent } from '@xstyled/styled-components'
import { variant, breakpoints } from '@xstyled/system'
import proportion from '@/modules/utils/proportion'

export const HeadingSeperateLine = styled.div`
  border-bottom: 1px solid black;
`

const varHeadingCont = variant({
  default: 'light',
  prop: 'variant',
  variants: {
    dark: css`
      border-bottom-color: #666;
    `,
    light: css`
      border-bottom-color: #000;
    `,
  },
})

const varIcon = variant({
  default: 'light',
  prop: 'variant',
  variants: {
    dark: css`
      background: url('/images/form/calendar-icon-light.png') no-repeat;
    `,
    light: css`
      background: url('/images/form/calendar-icon-dark.png') no-repeat;
    `,
    lightDetails: css`
      background: url('/images/form/details-icon-light.png') no-repeat;
    `,
    darkDetails: css`
      background: url('/images/form/details-icon-dark.png') no-repeat;
    `,
    lightTimes: css`
      background: url('/images/form/details-icon-light.png') no-repeat;
    `,
    darkTimes: css`
      background: url('/images/form/details-icon-dark.png') no-repeat;
    `,
  },
})

export const ContainerHeading: StyledComponent<
  'div',
  Record<string, unknown>,
  { variant: string },
  never
> = styled.div`
  border-bottom-style: solid;
  border-bottom-width: ${(props) => (props.noLine ? '0px' : '1px')};
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 20px;
  ${varHeadingCont};
  overflow: hidden;

  > .line {
    width: 100%;
  }
`

export const Title = styled.h1`
  font-family: title;
  font-size: ${proportion(60, 'handheld')};
  ${breakpoints({
    md: css`
      font-size: ${proportion(40, 'desktop')};
    `,
    xl: css`
      font-size: 40px;
    `,
  })}
  line-height: 40px;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin: 0;
`

export const Icon: StyledComponent<
  'div',
  Record<string, unknown>,
  { variant: string },
  never
> = styled.div`
  height: 38px;
  ${varIcon}
  width: 35px;
  background-size: contain;
  opacity: 0;
`
